export enum MutationType {
  CREATE,
  UPDATE,
}
